export default __webpack_public_path__ + "static/media/screen1.958aa1c8.png";